/* import __COLOCATED_TEMPLATE__ from './configuration-selector.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import { tracked } from '@glimmer/tracking';
import type StandardizedPlatform from 'embercom/objects/standalone/platforms/standardized-platform';
import type AppService from 'embercom/services/app-service';

interface Signature {
  Args: {
    platform: StandardizedPlatform<any>;
    formatLabel: (config: any) => string;
    requireConversationSyncing?: boolean;
    redirectLocation?: string;
  };
}

export default class ConfigurationSelector extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare appService: AppService;

  @tracked showAddConnectionDrawer = false;

  get platform() {
    return this.args.platform;
  }

  get configurations() {
    return this.platform.configurations ?? [];
  }

  get activeConfiguration() {
    return this.platform.activeConfiguration;
  }

  get showSelector() {
    return (
      this.appService.app.canUseStandaloneMultiEnv &&
      (this.configurations.length > 1 || this.activeConfiguration?.isConnected)
    );
  }

  get configurationOptions() {
    return this.configurations.map((config) => ({
      value: config.id,
      text: this.args.formatLabel(config),
    }));
  }

  @action
  selectConfiguration(configId: string) {
    let config = this.configurations.find((c) => c.id === configId);
    if (config) {
      this.platform.switchToConfiguration(config);
    }
  }

  @action
  openAddConnectionDrawer() {
    this.showAddConnectionDrawer = true;
  }

  @action
  closeAddConnectionDrawer() {
    this.showAddConnectionDrawer = false;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::ConfigurationSelector': typeof ConfigurationSelector;
    'standalone/configuration-selector': typeof ConfigurationSelector;
  }
}
